import env from "./envConfig";

export const symphonyApiConfig = {
	apiVersion: env.REACT_APP_SYMPHONY_API_VERSION,
};
